import React from 'react';
import AnimatedSection from "./AnimatedSection";
import 'bootstrap/dist/css/bootstrap.min.css';

function Cennik() {
    return (
      <AnimatedSection>
        <div className="container mt-5 text-white">
            <h1>Cennik</h1>
            <div className='spacer50'></div>
            <table className="table table-custom">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">Cena</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><p>KARNET 4 WEJŚCIA &nbsp;(ważny 4 tygodnie)</p></td>
                        <td>120zł</td>
                    </tr>
                    <tr>
                        <td><p>KARNET 8 WEJŚĆ &nbsp;(ważny 5 tygodni)</p></td>
                        <td>200zł</td>
                    </tr>
                    <tr>
                        <td><p>Wejście jednorazowe</p></td>
                        <td>40zł</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </AnimatedSection>
    );
}

export default Cennik;